/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCreditCardPlus: {
  name: 'credit-card-plus';
  data: string;
} = {
  name: 'credit-card-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a1 1 0 1 0 0-2H3v-7h16v2a1 1 0 1 0 2 0V5a2 2 0 0 0-2-2H3Zm16 5V5H3v3h16ZM5 14a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm9-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm3 5a1 1 0 0 1 1-1h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
